import React from 'react'
import { twMerge } from 'tailwind-merge'

import { ArrowBackIcon, ArrowRightIcon } from '../../icons'
import { Button } from '../button'
import { ButtonIcon } from '../button-icon'
import { CarouselDots } from '../carousel-dots'
import { HStack } from '../hstack'
import { IconSource } from '../icon'

// Carousel pager (Figma "Modal / What's new", node 11962:157874): two square
// `action`-bordered arrow buttons flanking a row of dots (see `CarouselDots`).
// Prop-driven and controlled: the parent owns `activeIndex` and the paging.

export type CarouselIndicatorProps = {
    count: number
    activeIndex: number
    onPrev: () => void
    onNext: () => void
    onDotPress?: (index: number) => void
    className?: string
    testID?: string
}

// The arrows are the shared secondary Button: on a brand-filled hover/pressed
// state its glyph flips to `on-primary` ink, which a hand-rolled Pressable kept
// missing (white-on-yellow on AOIMS, AOS-1278 / AOS-1187).
const ArrowButton: React.FC<{ icon: IconSource; onPress: () => void; label: string }> = ({
    icon,
    onPress,
    label,
}) => (
    <Button
        type='secondary'
        onPress={onPress}
        accessibilityRole='button'
        accessibilityLabel={label}
        iconLeft={<ButtonIcon as={icon} size={24} />}
    />
)

export const CarouselIndicator: React.FC<CarouselIndicatorProps> = ({
    count,
    activeIndex,
    onPrev,
    onNext,
    onDotPress,
    className,
    testID,
}) => (
    <HStack testID={testID} className={twMerge('items-center justify-center gap-4', className)}>
        <ArrowButton icon={ArrowBackIcon} onPress={onPrev} label='Previous' />

        <CarouselDots count={count} activeIndex={activeIndex} onDotPress={onDotPress} />

        <ArrowButton icon={ArrowRightIcon} onPress={onNext} label='Next' />
    </HStack>
)
CarouselIndicator.displayName = 'CarouselIndicator'
